module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "totalSales"
  }, [_c('div', {
    staticClass: "tableConBox",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showType = false
      }
    }
  }, [_c('div', {
    staticClass: "tableTem",
    on: {
      "click": function($event) {
        _vm.searchList = []
      }
    }
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix"
  }, [(_vm.searchByWhichType == 'dayOrMonth') ? _c('div', {
    staticClass: "change-type"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.nowType = 'day'
      }
    }
  }, [_vm._v("日报")]), _vm._v(" "), _c('span', {
    class: _vm.nowType == 'day' ? 'type-wrap' : 'type-wrap to-right',
    on: {
      "click": function($event) {
        _vm.nowType == 'day' ? _vm.nowType = 'month' : _vm.nowType = 'day'
      }
    }
  }, [_c('i', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  })]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        _vm.nowType = 'month'
      }
    }
  }, [_vm._v("月报")])]) : _vm._e(), _vm._v(" "), (_vm.nowType == 'month' && _vm.searchByWhichType == 'dayOrMonth') ? _c('div', {
    staticClass: "month-filter"
  }, [_c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "value-format": "yyyy-MM",
      "format": "yyyy 年 MM 月",
      "picker-options": _vm.pickerOptions0,
      "type": "month",
      "placeholder": "选择月"
    },
    model: {
      value: (_vm.valueForMonth),
      callback: function($$v) {
        _vm.valueForMonth = $$v
      },
      expression: "valueForMonth"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.nowType == 'day' && _vm.searchByWhichType == 'dayOrMonth') ? _c('div', {
    staticClass: "day-filter"
  }, [_c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptionsForDay
    },
    model: {
      value: (_vm.nowDay),
      callback: function($$v) {
        _vm.nowDay = $$v
      },
      expression: "nowDay"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchByWhichType == 'timeRange' && !_vm.isUseRangeTime),
      expression: "searchByWhichType=='timeRange'&&!isUseRangeTime"
    }],
    staticClass: "time-range-filter"
  }, [_c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "datetime",
      "default-time": "00:00:00",
      "picker-options": _vm.pickerOptionsForTimeRange,
      "placeholder": "开始时间"
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "datetime",
      "default-time": "23:59:59",
      "picker-options": _vm.pickerOptionsForTimeRange,
      "placeholder": "结束时间"
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchByWhichType == 'timeRange' && _vm.isUseRangeTime),
      expression: "searchByWhichType=='timeRange'&&isUseRangeTime"
    }],
    staticClass: "time-range-filter"
  }, [_c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "date",
      "default-time": "00:00:00",
      "picker-options": _vm.pickerOptionsForTimeRange,
      "placeholder": "开始时间"
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "date",
      "default-time": "23:59:59",
      "picker-options": _vm.pickerOptionsForTimeRange,
      "placeholder": "结束时间"
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  })], 1), _vm._v(" "), (_vm.searchByWhichType == 'timeRange') ? _c('el-checkbox', {
    model: {
      value: (_vm.isUseRangeTime),
      callback: function($$v) {
        _vm.isUseRangeTime = $$v
      },
      expression: "isUseRangeTime"
    }
  }, [_vm._v("每一天的时间段")]) : _vm._e(), _vm._v(" "), (_vm.searchByWhichType == 'timeRange' && _vm.isUseRangeTime) ? _c('el-time-picker', {
    staticClass: "dateTime",
    attrs: {
      "is-range": "",
      "range-separator": "至",
      "start-placeholder": "开始时间",
      "end-placeholder": "结束时间",
      "placeholder": "选择时间范围"
    },
    model: {
      value: (_vm.rangeTime),
      callback: function($$v) {
        _vm.rangeTime = $$v
      },
      expression: "rangeTime"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "types"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.orderSource),
      callback: function($$v) {
        _vm.orderSource = $$v
      },
      expression: "orderSource"
    }
  }, _vm._l((_vm.orderSourceOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "types"
  }, [_vm._v("\n                        分类选择：\n                        "), _vm._v(" "), _c('div', {
    staticClass: "type-sel",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showType = !_vm.showType
      }
    }
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v(_vm._s(_vm.isSelAll ? '全部' : (_vm.selType.length > 0 ? ((_vm.selType[0]) + "...") : '分类选择')))]), _vm._v(" "), (_vm.showType) ? _c('div', {
    staticClass: "type-item",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('ul', [_c('li', [_c('div', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isSelAll),
      expression: "isSelAll"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": 'ALL',
      "checked": Array.isArray(_vm.isSelAll) ? _vm._i(_vm.isSelAll, 'ALL') > -1 : (_vm.isSelAll)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.selAll.apply(null, arguments)
      },
      "change": function($event) {
        var $$a = _vm.isSelAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 'ALL',
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isSelAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isSelAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isSelAll = $$c
        }
      }
    }
  }), _vm._v("全部")])]), _vm._v(" "), _vm._l((_vm.options), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selType),
        expression: "selType"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.value,
        "checked": Array.isArray(_vm.selType) ? _vm._i(_vm.selType, item.value) > -1 : (_vm.selType)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selType,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selType = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selType = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selType = $$c
          }
        }
      }
    }), _vm._v(_vm._s(item.label))])])
  })], 2)])]) : _vm._e()])]), _vm._v(" "), _c('span', {
    staticClass: "quick-filter"
  }, [_c('span', {
    class: _vm.nowSelFilter == 'today' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('today')
      }
    }
  }, [_vm._v("今日")]), _vm._v(" "), _c('span', {
    class: _vm.nowSelFilter == 'lastDay' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('lastDay')
      }
    }
  }, [_vm._v("昨日")]), _vm._v(" "), _c('span', {
    class: _vm.nowSelFilter == 'week' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('week')
      }
    }
  }, [_vm._v("本周")]), _vm._v(" "), _c('span', {
    class: _vm.nowSelFilter == 'lastWeek' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('lastWeek')
      }
    }
  }, [_vm._v("上周")]), _vm._v(" "), _c('span', {
    class: _vm.nowSelFilter == 'month' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('month')
      }
    }
  }, [_vm._v("本月")]), _vm._v(" "), _c('span', {
    class: _vm.nowSelFilter == 'lastMonth' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('lastMonth')
      }
    }
  }, [_vm._v("上月")])]), _vm._v(" "), _c('span', {
    staticClass: "types typesSearch"
  }, [_c('span', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searchConfirm
    }
  }, [_vm._v("查询")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#f54747",
      "font-size": "14px",
      "lineHeight": "18px"
    }
  }, [_vm._v("不包含会员充值和退单数据！")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), (_vm.nowType == 'day' && _vm.searchByWhichType == 'dayOrMonth') ? _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [(_vm.workData.length > 0) ? _c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.workData.length > 10
    }
  }, _vm._l((_vm.workData), function(item, ind) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [(item.name) ? _c('span', {
      domProps: {
        "textContent": _vm._s(ind + 1)
      }
    }) : _vm._e(), _vm._v(" "), (!item.name) ? _c('span') : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      domProps: {
        "textContent": _vm._s(item.qty)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      domProps: {
        "textContent": _vm._s(item.salesPrice)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      },
      domProps: {
        "textContent": _vm._s(item.parentTypeName)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      },
      domProps: {
        "textContent": _vm._s(item.typeName)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(_vm._f("toFixedNum")(item.amount)))])])
  }), 0) : _c('div', {
    staticClass: "no-data"
  }, [_vm._v("\n                                暂无记录，请点击查询或者重新选择查询条件。\n                            ")])])]) : _vm._e(), _vm._v(" "), (_vm.nowType == 'month' && _vm.searchByWhichType == 'dayOrMonth') ? _c('div', {
    staticClass: "tableBox scrollBox tableBox-for-month"
  }, [_c('div', {
    staticClass: "scroll"
  }, [(_vm.workDataForMonth.length > 0) ? _c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.workDataForMonth.length > 10
    }
  }, _vm._l((_vm.workDataForMonth), function(item, ind) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [(item.name) ? _c('span', {
      domProps: {
        "textContent": _vm._s(ind + 1)
      }
    }) : _vm._e(), _vm._v(" "), (!item.name) ? _c('span') : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      domProps: {
        "textContent": _vm._s(item.qty)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      domProps: {
        "textContent": _vm._s(item.salesPrice)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      },
      domProps: {
        "textContent": _vm._s(item.parentTypeName)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      },
      domProps: {
        "textContent": _vm._s(item.typeName)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(_vm._f("toFixedNum")(item.amount)))])])
  }), 0) : _c('div', {
    staticClass: "no-data"
  }, [_vm._v("\n                                暂无记录，请点击查询或者重新选择查询条件。\n                            ")])])]) : _vm._e(), _vm._v(" "), (_vm.searchByWhichType == 'timeRange') ? _c('div', {
    staticClass: "tableBox scrollBox tableBox-for-month"
  }, [_c('div', {
    staticClass: "scroll"
  }, [(_vm.workDataForTimeRange.length > 0) ? _c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.workDataForTimeRange.length > 10
    }
  }, _vm._l((_vm.workDataForTimeRange), function(item, ind) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [(item.name) ? _c('span', {
      domProps: {
        "textContent": _vm._s(ind + 1)
      }
    }) : _vm._e(), _vm._v(" "), (!item.name) ? _c('span') : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      domProps: {
        "textContent": _vm._s(item.qty)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      domProps: {
        "textContent": _vm._s(item.salesPrice)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      },
      domProps: {
        "textContent": _vm._s(item.parentTypeName)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      },
      domProps: {
        "textContent": _vm._s(item.typeName)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(_vm._f("toFixedNum")(item.amount)))])])
  }), 0) : _c('div', {
    staticClass: "no-data"
  }, [_vm._v("\n                                暂无记录，请点击查询或者重新选择查询条件。\n                            ")])])]) : _vm._e()])]), _vm._v(" "), (_vm.nowType == 'day' && _vm.searchByWhichType == 'dayOrMonth') ? _c('div', {
    staticClass: "pager flex flex-align-center"
  }, [_c('div', {
    staticClass: "pagerCon clearfix"
  }, [_c('span', {
    staticClass: "right excel",
    on: {
      "click": _vm.excel
    }
  }, [_vm._v("导出Excel")]), _vm._v(" "), _c('span', {
    staticClass: "left item"
  }, [_vm._v("数量:"), _c('span', {
    staticClass: "num color3",
    domProps: {
      "textContent": _vm._s(_vm.allQty)
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "left item"
  }, [_vm._v("总收入:"), _c('span', {
    staticClass: "num color5"
  }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.allAmount)))]), _vm._v(" "), (_vm.channelInfo) ? _c('span', {
    staticClass: "channel-info"
  }, [_c('span', [_vm._v("微信：" + _vm._s(_vm.channelInfo.wechatAmount))]), _vm._v(" "), _c('span', [_vm._v("、支付宝：" + _vm._s(_vm.channelInfo.aliAmount))]), _vm._v(" "), _c('span', [_vm._v("、会员支付：" + _vm._s(_vm.channelInfo.memberAmount))]), _vm._v(" "), _c('span', [_vm._v("、银联支付：" + _vm._s(_vm.channelInfo.unionpayAmount))]), _vm._v(" "), _c('span', [_vm._v("、现金支付：" + _vm._s(_vm.channelInfo.cashAmount))])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.nowType == 'month' && _vm.searchByWhichType == 'dayOrMonth') ? _c('div', {
    staticClass: "pager flex flex-align-center"
  }, [_c('div', {
    staticClass: "pagerCon clearfix"
  }, [_c('span', {
    staticClass: "right excel",
    on: {
      "click": _vm.excel
    }
  }, [_vm._v("导出Excel")]), _vm._v(" "), _c('span', {
    staticClass: "left item"
  }, [_vm._v("数量:"), _c('span', {
    staticClass: "num color3",
    domProps: {
      "textContent": _vm._s(_vm.allQtyForMonth)
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "left item"
  }, [_vm._v("总收入:"), _c('span', {
    staticClass: "num color5"
  }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.allAmountForMonth)))]), _vm._v(" "), (_vm.channelInfo) ? _c('span', {
    staticClass: "channel-info"
  }, [_c('span', [_vm._v("微信：" + _vm._s(_vm.channelInfo.wechatAmount))]), _vm._v(" "), _c('span', [_vm._v("、支付宝：" + _vm._s(_vm.channelInfo.aliAmount))]), _vm._v(" "), _c('span', [_vm._v("、会员支付：" + _vm._s(_vm.channelInfo.memberAmount))]), _vm._v(" "), _c('span', [_vm._v("、银联支付：" + _vm._s(_vm.channelInfo.unionpayAmount))]), _vm._v(" "), _c('span', [_vm._v("、现金支付：" + _vm._s(_vm.channelInfo.cashAmount))])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.searchByWhichType == 'timeRange') ? _c('div', {
    staticClass: "pager flex flex-align-center"
  }, [_c('div', {
    staticClass: "pagerCon clearfix"
  }, [_c('span', {
    staticClass: "right excel",
    on: {
      "click": _vm.excel
    }
  }, [_vm._v("导出Excel")]), _vm._v(" "), _c('span', {
    staticClass: "left item"
  }, [_vm._v("数量:"), _c('span', {
    staticClass: "num color3",
    domProps: {
      "textContent": _vm._s(_vm.allQtyForTimeRange)
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "left item"
  }, [_c('span', [_vm._v("总收入:  \n                            "), _c('span', {
    staticClass: "num color5"
  }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.allAmountForTimeRange)))]), _vm._v(" "), (_vm.channelInfo && _vm.channelInfo.memberAmount) ? _c('span', {
    staticClass: "num color5",
    staticStyle: {
      "font-size": "16px",
      "padding-right": "10px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("总实收：")]), _c('span', {
    staticStyle: {
      "font-size": "22px"
    }
  }, [_vm._v(_vm._s((_vm.allAmountForTimeRange - _vm.channelInfo.memberAmount).toFixed(2)))])]) : _vm._e()]), _vm._v(" "), (_vm.channelInfo) ? _c('span', {
    staticClass: "channel-info"
  }, [_c('span', [_vm._v("微信：" + _vm._s(_vm.channelInfo.wechatAmount))]), _vm._v(" "), _c('span', [_vm._v("、支付宝：" + _vm._s(_vm.channelInfo.aliAmount))]), _vm._v(" "), _c('span', [_vm._v("、会员支付：" + _vm._s(_vm.channelInfo.memberAmount))]), _vm._v(" "), _c('span', [_vm._v("、银联支付：" + _vm._s(_vm.channelInfo.unionpayAmount))]), _vm._v(" "), _c('span', [_vm._v("、现金支付：" + _vm._s(_vm.channelInfo.cashAmount))])]) : _vm._e()])])]) : _vm._e()])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "scrollBox"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("商品名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("数量")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("售价")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("一级分类")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("二级分类")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("总计")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-f12aae3c","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/indexRouters/saleInfo/totalSales/totalSales.vue
// module id = 990
// module chunks = 1